'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uxcore = require('@ux/uxcore2');

function applyReplacements(text, waitTimes) {
  var replacedText = text;
  Object.keys(waitTimes).filter(function (key) {
    return waitTimes[key] && waitTimes[key] !== 'unknown';
  }).forEach(function (key) {
    var re = new RegExp('\\${' + key + '}', 'g');
    replacedText = replacedText.replace(re, waitTimes[key]);
  });
  return replacedText;
}

function applyDefaults(text, defaultText) {
  if (/\${[a-zA-Z]+}/.test(text)) {
    return defaultText;
  }
  return text;
}

function getFieldValue(item, fieldName, fieldType, defaultValue) {
  if (item && item.props && item.props.msg && item.props.msg.payload && item.props.msg.payload.fields && item.props.msg.payload.fields[fieldName]) {
    var field = item.props.msg.payload.fields[fieldName];
    var fieldValue = field[fieldType + 'Value'];

    return fieldValue ? fieldValue : defaultValue;
  }

  return defaultValue;
}

function getMessageText(item, waitTimes) {
  var msgText = '';
  if (item && item.msg && item.msg.text && item.msg.text.text && item.msg.text.text.length) {
    msgText = item.msg.text.text[0];
    return msgText;
  }
  if (waitTimes && item && item.msg && item.msg.payload && item.msg.payload.fields && item.msg.payload.fields.type && item.msg.payload.fields.type.stringValue === 'text') {
    var text = item.msg.payload.fields.text && item.msg.payload.fields.text.stringValue || '';
    var defaultText = item.msg.payload.fields.defaultText && item.msg.payload.fields.defaultText.stringValue || '';
    return applyDefaults(applyReplacements(text, waitTimes), defaultText);
  }
  return msgText;
}

function getMessageItemsArray(item) {
  if (item && item.props && item.props.msg && item.props.msg.payload && item.props.msg.payload.fields && item.props.msg.payload.fields.items) {
    return item.props.msg.payload.fields.items;
  }
  return null;
}

function applySplit(items, split) {
  if (items.listValue && split) {
    window._expDataLayer = window._expDataLayer || [];
    window._expDataLayer.push({
      schema: 'add_experiment',
      version: 'v1',
      data: {
        experiment_id: split.experimentId,
        variant_id: split.variantId,
        experiment_source: 'SplitIO'
      }
    });
    var filteredValues = items.listValue.values.filter(function (element) {
      return !element.structValue.fields.splitSide || element.structValue.fields.splitSide.stringValue === split.variantId;
    });
    items.listValue.values = filteredValues;
  }
}

function applyFilter(items, waitTimes) {
  if (waitTimes && waitTimes.estimatedPhoneWaitTime === 'unknown' && items.listValue) {
    var filteredValues = items.listValue.values.filter(function (element) {
      return !element.structValue.fields.filter || element.structValue.fields.filter.stringValue !== 'estimatedPhoneWaitTime';
    });
    items.listValue.values = filteredValues;
  }
}

function applyWaitTimes(items, waitTimes) {
  if (items.listValue && waitTimes) {
    var listValuesString = JSON.stringify(items.listValue);
    listValuesString = applyReplacements(listValuesString, waitTimes);
    var listValue = JSON.parse(listValuesString);

    // use default for any non replaced strings.
    listValue.values.forEach(function (element) {
      var text = element.structValue.fields.label.stringValue;
      var defaultText = element.structValue.fields.defaultLabel && element.structValue.fields.defaultLabel.stringValue || '';
      element.structValue.fields.label.stringValue = applyDefaults(text, defaultText);
    });
    items.listValue = listValue;
  }
}

function getQueryPayloadsNextEvent(msg, queryApiUrl, callback) {
  if (msg && msg.payload && msg.payload.fields) {
    var _msg$payload$fields = msg.payload.fields,
        botProjectId = _msg$payload$fields.botProjectId,
        stopCondition = _msg$payload$fields.stopCondition,
        eventNameProceed = _msg$payload$fields.eventNameProceed,
        eventNameStop = _msg$payload$fields.eventNameStop;

    if (botProjectId && stopCondition && eventNameProceed && eventNameStop) {
      _uxcore.utils.request.get(queryApiUrl + '&projectId=' + botProjectId.stringValue, { mode: 'cors' }, function (err, data) {
        err = err || data && data.err || null;
        if (err) {
          return;
        }
        var intentName = data.responseData && data.responseData.queryResult && data.responseData.queryResult.intent && data.responseData.queryResult.intent.displayName;
        if (intentName) {
          var matchExcludeIntents = stopCondition.listValue.values.find(function (intent) {
            return intentName.toLowerCase().indexOf(intent.stringValue) > -1;
          });
          if (matchExcludeIntents) {
            callback(eventNameStop.stringValue);
          } else {
            callback(eventNameProceed.stringValue);
          }
        }
      });
    }
  }
}

var getBotSwitcherNextUtterance = function getBotSwitcherNextUtterance(msg, helpBot) {
  if (msg && msg.payload && msg.payload.fields) {
    var _msg$payload$fields2 = msg.payload.fields,
        nextEvent = _msg$payload$fields2.nextEvent,
        nextUtteranceIndex = _msg$payload$fields2.nextUtteranceIndex;

    if (nextEvent) return {
      nextEvent: nextEvent.stringValue
    };
    if (nextUtteranceIndex && nextUtteranceIndex.numberValue !== null) {
      var userTypedMessages = helpBot.props.conversation.filter(function (message) {
        return message.msgType === 'user';
      }).sort(function (a, b) {
        return b.index - a.index;
      });
      if (nextUtteranceIndex.numberValue < userTypedMessages.length) {
        return {
          nextUtterance: userTypedMessages[nextUtteranceIndex.numberValue].msg
        };
      }

      return {
        nextEvent: helpBot.getFallbackIntentEventId()
      };
    }
  }
};

exports.default = {
  getFieldValue: getFieldValue,
  getMessageText: getMessageText,
  getMessageItemsArray: getMessageItemsArray,
  getQueryPayloadsNextEvent: getQueryPayloadsNextEvent,
  getBotSwitcherNextUtterance: getBotSwitcherNextUtterance,
  applyWaitTimes: applyWaitTimes,
  applySplit: applySplit,
  applyFilter: applyFilter
};